import { render, staticRenderFns } from "./buttonUpload.vue?vue&type=template&id=92afb912&scoped=true&"
import script from "./buttonUpload.vue?vue&type=script&lang=js&"
export * from "./buttonUpload.vue?vue&type=script&lang=js&"
import style0 from "./buttonUpload.vue?vue&type=style&index=0&id=92afb912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92afb912",
  null
  
)

export default component.exports